
import { Box, Typography, useMediaQuery, useTheme } from "@mui/material";
import { Share2 } from "lucide-react";
import { Dispatch, SetStateAction } from "react";
import { useTranslation } from "react-i18next";

type IShare = {
  setCommentModalIsOpen: Dispatch<SetStateAction<boolean>>
}

export const Share = (
  { setCommentModalIsOpen }:IShare
) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const isMedium = useMediaQuery(theme.breakpoints.down(950));

  return (
    <Box
      id="button-sharing"
      role="button"
      className="button"
      aria-label={ t("share_comment") }
      tabIndex={ 0 }
      position={ "relative" }

      sx={ {
        gap: "0.5rem",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "1rem 0.75rem",
        cursor: "pointer"
      } }
      alignItems="center"
      onClick={ () => { setCommentModalIsOpen(true) } }
      onKeyDown={ (e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          setCommentModalIsOpen(true);
        }
      } }
    >
      <Share2 size={ "1rem" } />
      { !isMedium && (
        <Typography fontSize={ "0.875rem" }>
          { t("share") }
        </Typography>
      ) }
    </Box>
  );
};
